/**
 * LazyComponents.tsx
 * Composants lazy-loaded pour améliorer les performances
 * Phase 3.1 : Optimisation des performances
 */
import { lazy } from 'react';

// Modals - Lazy loading car ils ne sont pas toujours affichés
export const OnboardingModal = lazy(() =>
  import('../OnboardingModal').then(module => ({ default: module.OnboardingModal }))
);

export const HelpModal = lazy(() =>
  import('../HelpModal').then(module => ({ default: module.HelpModal }))
);

export const UserGuide = lazy(() =>
  import('../Help/UserGuide').then(module => ({ default: module.UserGuide }))
);

export const InteractiveTutorial = lazy(() =>
  import('../Tutorial/InteractiveTutorial').then(module => ({
    default: module.InteractiveTutorial,
  }))
);

export const KeyboardShortcutsModal = lazy(() =>
  import('../Help/KeyboardShortcutsModal').then(module => ({
    default: module.KeyboardShortcutsModal,
  }))
);

export const ExportModal = lazy(() =>
  import('../ExportModal').then(module => ({ default: module.ExportModal }))
);

export const ExportPreviewModal = lazy(() =>
  import('../ExportPreviewModal').then(module => ({ default: module.ExportPreviewModal }))
);

export const VariablesManagerModal = lazy(() =>
  import('../VariablesManagerModal').then(module => ({ default: module.VariablesManagerModal }))
);

export const ImageCropModal = lazy(() =>
  import('../ImageCrop/ImageCropModal').then(module => ({ default: module.ImageCropModal }))
);

// Composants lourds - Lazy loading
export const TemplateGallery = lazy(() =>
  import('../TemplateGallery').then(module => ({ default: module.TemplateGallery }))
);

export const AssetsLibrary = lazy(() =>
  import('../AssetsLibrary').then(module => ({ default: module.AssetsLibrary }))
);

export const TemplateDashboard = lazy(() =>
  import('../TemplateDashboard/TemplateDashboard').then(module => ({
    default: module.TemplateDashboard,
  }))
);

// Composants de canvas - Lazy loading conditionnel
export const CanvasMinimap = lazy(() =>
  import('../Canvas/CanvasMinimap').then(module => ({ default: module.CanvasMinimap }))
);

export const CanvasNavigationBar = lazy(() =>
  import('../Canvas/CanvasNavigationBar').then(module => ({ default: module.CanvasNavigationBar }))
);
